import { Card, Col, Divider, Row } from "antd";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import OtpGeneratorForm from "../../components/otp/otp-generator-form";
import OtpHistoryTable from "../../components/otp/otp-history-table";
import OtpResultCard from "../../components/otp/otp-result-card";
import PageHeader from "../../components/general/layout/page-header";
import { IGenerateOtpResponse, IOtpLogEntry } from "../../models/otp/response";
import EndPoints from "../../services/end-points";
import { execute } from "../../utils/helpers/execute";
import styles from "./style.module.scss";

const OtpGeneratorPage: React.FC = () => {
  const { t } = useTranslation();
  const [latestOtp, setLatestOtp] = useState<IGenerateOtpResponse | null>(null);
  const [otpHistory, setOtpHistory] = useState<IOtpLogEntry[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const loadLogs = async () => {
    setLoading(true);
    await execute({
      callback: async () => {
        const response = await EndPoints.otp.fetchLogs(20);
        if (response && response.data && response.data.data) {
          setOtpHistory(response.data.data);
        }
      },
    });
    setLoading(false);
  };

  useEffect(() => {
    loadLogs();
  }, []);

  const handleNewOtp = (result: IGenerateOtpResponse) => {
    setLatestOtp(result);
    loadLogs(); // Reload logs from server after generating new OTP
  };

  return (
    <div className={styles.otpGeneratorPage}>
      <PageHeader title={t("otp_generator")} />

      <Row gutter={[16, 16]}>
        <Col xs={24} lg={12}>
          <Card title={t("generate_new_code")} bordered={false}>
            <OtpGeneratorForm onSuccess={handleNewOtp} />
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          {latestOtp && <OtpResultCard result={latestOtp} />}
        </Col>
      </Row>

      <Divider />
      <Card title={t("otp_history")} bordered={false}>
        <OtpHistoryTable data={otpHistory} loading={loading} />
      </Card>
    </div>
  );
};

export default OtpGeneratorPage;
